import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const IELTSResultsWithSidebar = () => {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set('view', 'results');
  return <Navigate to={`/ielts-dashboard?${next}`} replace />;
};

export default IELTSResultsWithSidebar;
